import { type CategorizedResponse, groundApi } from "@b2bportal/ground-api";
import { axiosInstance } from "@hopper-b2b/api";
import type { CarLocationSuggestion } from "@tenant/cars";

// TODO: REUSE core-cars when it is ready, but currently it is calling lodging-api instead.
export const fetchLocations = async (
  search: string,
  callback: (newOptions: CarLocationSuggestion[]) => void
): Promise<void> => {
  try {
    const res = await groundApi(axiosInstance).apiV1AutocompleteGroundPost({
      query: { l: search, LocationQuery: "Label" },
    });

    const options: CarLocationSuggestion[] =
      res.data.categories?.flatMap((categoryRes: CategorizedResponse) =>
        categoryRes.results.map((s) => ({
          ...s,
          category: categoryRes.category,
          categoryLabel: categoryRes.label,
        }))
      ) ?? [];
    callback(options);
  } catch (e) {
    callback([]);
  }
};
